module.exports = __webpack_public_path__ + "img/test1.c6400462.jpg";